<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">
          {{ $t('user.pageTitle') }}
        </h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{
                $t('user.warehouseLocation')
              }}</label>
              <div>
                <ts-loading-banner :loading="loadingPreData">
                  <treeselect
                    :options="
                      warehouses.map(i => ({
                        id: i.location_id,
                        label:
                          i.location_name +
                          (i.is_main_warehouse ? ' (Is Main)' : '')
                      }))
                    "
                    placeholder="Type for search..."
                    v-model="location_id"
                  ></treeselect>
                </ts-loading-banner>
                <div
                  class="invalid-feedback"
                  v-if="errors.has('delete_reason')"
                >
                  {{ errors.first('delete_reason') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button
              class="btn-sm"
              @click.prevent="$emit('close')"
              :disabled="saving"
              >{{ $t('no') }}</ts-button
            >
            <ts-button
              color="primary"
              class="ml-2 btn-sm"
              :waiting="saving"
              :disabled="!location_id"
              @click.prevent="yes"
              >{{ $t('yes') }}</ts-button
            >
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  props: ['data'],
  name: 'chooseCashierLocation',
  data() {
    return {
      errors: new Errors(),
      loadingPreData: false,
      saving: false,
      warehouses: [],
      location_id: null
    }
  },
  created() {
    this.fetchLocation()
  },
  methods: {
    ...mapActions('user', ['getWarehouse']),
    fetchLocation() {
      this.loadingPreData = true
      this.getWarehouse({
        branch_id: [this.data.branch_id]
      })
        .then(response => {
          this.warehouses = response.data
          this.loadingPreData = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loadingPreData = false
        })
    },
    yes() {
      this.saving = true
      this.$store
        .dispatch('user/switchDefaultBranch', {
          branch_id: this.data.branch_id,
          location_id: this.location_id
        })
        .then(() => {
          this.saving = false
          this.$emit('close')
          this.logout()
          window.location.href = this.data.company.system_url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.saving = false
        })
    },
    async logout() {
      await this.$store.dispatch('logout')
    }
  }
}
</script>
